import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { W2d2dNavigation } from "../../../../W2d2dNavigation.tsx";
import { Idea, IdeaAccessors, w2d2dApiClient } from "../../../../w2d2d-api-client";
import EditIdeaPage, { IdeaDraft } from "./EditIdeaPage";
import { Typography } from "@mui/material";

export default function EditIdeaRoute() {

    const navigate = useNavigate()
    const location = useLocation()

    const { id } = useParams()

    const [idea, setIdea] = useState<undefined | null | Idea>(undefined)
    const [ideaAccessors, setIdeaAccessors] = useState<undefined | null | IdeaAccessors>(undefined)

    useEffect(() => {
        if (!id) {
            W2d2dNavigation.ideas.navigate(navigate, location)
            return
        }

        w2d2dApiClient.getIdea({ id })
            .then(idea => {
                setIdea(idea)
            })
            .catch(() => {
                setIdea(null)
            })
        w2d2dApiClient.getIdeaAccessors({ id })
            .then(ideaAccessors => {
                setIdeaAccessors(ideaAccessors)
            })
            .catch(() => {
                setIdeaAccessors(null)
            })
    }, [setIdea, navigate, location])

    if (idea === null || ideaAccessors === null) {
        // TODO: general not found page?
        return (
            <Typography variant="h4">Idee nicht gefunden</Typography>
        )
    }

    if (idea && ideaAccessors) {
        let startsAt = new Date()
        if (idea.startsAt) {
            startsAt = new Date(idea.startsAt)
        }
        let duration = 2
        if (idea.startsAt && idea.endsAt) {
            let diff = Date.parse(idea.endsAt) - Date.parse(idea.startsAt)
            if (diff > 0) {
                duration = diff / (1000 * 60 * 60)
            }
        }
        const ideaDraft: IdeaDraft = {
            id: idea.id,
            title: idea.title,
            description: idea.description,
            startsAt: startsAt,
            duration: duration,
            accessors: ideaAccessors,
        }
        return (
            <EditIdeaPage ideaDraft={ideaDraft} />
        )
    }
}
